/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'caret-up': {
    width: 1000,
    height: 1000,
    viewBox: '0 0 1000 1000',
    data: '<path pid="0" d="M534.3 362.8l254.8 254.8c18.9 18.9 12.6 34.3-14.2 34.3H225.1c-26.8 0-33.1-15.3-14.2-34.3l254.8-254.8c19-18.9 49.6-18.9 68.6 0z"/>'
  }
})
